<app-dialog-header [title]="'scheduler.setup.location.title' | translate" (closeClicked)="onCancel()">
</app-dialog-header>

<div mat-dialog-content>

  @if (!foundResult) {

  <p>Search by postcode in the box below.</p>
  <div class="postcode-search-container">
    <mat-form-field class="full-width">
      <mat-label>Search Location</mat-label>
      <input matInput [formControl]="postcodeSearchControl" placeholder="Start typing to search..."
        aria-label="Search Location" [matAutocomplete]="auto" autocomplete="off" autocapitalize="off" autocorrect="off"
        data-lpignore="true" spellcheck="false">
      @if (isLoading) {
      <mat-progress-spinner matSuffix color="primary" mode="indeterminate" diameter="20">
      </mat-progress-spinner>
      }
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPostcode($event.option.value)">
        @for (postcode of filteredPostcodes; track postcode.postcode) {
        <mat-option [value]="postcode">
          {{ postcode.postcode }}
        </mat-option>
        }
        @if (filteredPostcodes.length === 0 && postcodeSearchControl.value && postcodeSearchControl.value.length >=
        minSearchLength) {
        <mat-option disabled>No results found</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  }

  @if (!!foundResult) {
  <div class="result-container">
    <button (click)="reset()" mat-stroked-button>Reset</button>
    <div class="result-info">
      <h3>Found match: {{ result.postCode }}</h3>
      <p>
        Latitude / Longitude: {{ result.latitude }} / {{ result.longitude }}
      </p>
    </div>
    <button (click)="confirm()" mat-flat-button color="primary">Confirm</button>
  </div>
  }
</div>

<style>
  .postcode-search-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .full-width {
    width: 100%;
  }

  .result-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .result-info {
    margin: 16px 0;
    padding: 16px;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
</style>